var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabDiagnostics = function SvgTabDiagnostics(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon_1_",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tv",
    fill: "#525252",
    fillRule: "evenodd",
    d: "M27.651 3.953H4.34A4.355 4.355 0 0 0-.015 8.308v15.3a4.355 4.355 0 0 0 4.355 4.355h23.311a4.354 4.354 0 0 0 4.354-4.355v-15.3a4.353 4.353 0 0 0-4.354-4.355m1.341 18.051a2.954 2.954 0 0 1-2.955 2.955H5.955A2.955 2.955 0 0 1 3 22.004V9.913a2.955 2.955 0 0 1 2.955-2.955h20.082a2.954 2.954 0 0 1 2.955 2.955z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "graph",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.938 17.031 21.969 6.969l-4 10.031h-1.938l-1.937 3.969-4.719-8.906-3.344 4.968L2.938 17l.031 2H8l1.438-2.5 4.5 8.594L17.125 19h2.813l2-7 2.093 7L30 18.906v-1.875z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabDiagnostics);
export default ForwardRef;